<template>
  <div>
    <BallNumbers
      :numbers="numbersMainBallSet"
      @handleChosenItem="handleChosenNumber"
      @handleAddLine="$emit('handleAddLine')"
    />
  </div>
</template>

<script>
import BallNumbers from '@/components/common/ball/ball-numbers.vue';
export default {
  props: {
    numbersMainBallSet: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BallNumbers
  },
  methods: {
    handleChosenNumber(index) {
      this.$emit('handleChosenItem', {index, type: 'main'})
    }
  }
}
</script>

<style scoped>

</style>
